import { Tag } from '@duxton-web/ui';
import styled from 'styled-components';

export const MetricTag = styled(Tag)`
  border-radius: 8px;
  border: none;
  background-color: #f5f5f5;
  color: #3d3d3d;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  min-height: 40px;
  min-width: 40px;
  align-items: center;
  justify-content: center;
`;

export const MetricsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 8px;
  gap: 4px;
`;
